/**
 * Elenni homepage hero — lifestyle rotator (v3m7 — mobile page-load playlist fix)
 * Desktop/iPad: 2 TWIN equal panes, object-fit:cover, independent autoplay (LOCKED).
 * Mobile: single-hero playlist, contain #FAF7F2; Flickity autoplay paused.
 * HARD: never same image twice on one page load; never same category twice on one load;
 *       force Otti + Pietra Bianca/bath in playlist; no same range back-to-back;
 *       Fisher-Yates+Date.now seed so refresh varies; autoplay ~2s; light.
 * Room lifestyle only (macros/dials/blank bg/line drawings banned upstream).
 */
(function elenniHeroLifestyle() {
  var INTERVAL_MS = 2000;
  var PRELOAD_AHEAD = 2;
  var PANE_TARGET = 2;
  var reduced = false;
  try {
    reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  var CAT_BY_FN = {
    "harper-1500-florentine-walnut_aboveangle_e_1x1-web.jpg": "vanity",
    "adp-bronte-corner-g1.jpg": "bath",
    "14722_2.jpg": "otti_vanity",
    "54552899_Lifestyle_VE600WHA_1.jpg": "venetta",
    "phoenix-117-1125__lifestyle_117-1125-10_Phoenix_Axia_Wall_Basin_Bath_Hostess_Set_180mm_RGB.jpg": "wall_combo",
    "54552899_Lifestyle_MRV450SHAF_1.jpg": "space_saver",
    "phoenix-vs7630__VS7630-12-VS7801-12-Phoenix-Vivid-Slimline-Shower-Wall-Mixer-and-Outlet-Lifestyle-RGB-scaled.jpg": "shower",
    "13297_2.jpg": "led_mirror",
    "54552899_Lifestyle_CI420SMW_2.jpg": "basin",
    "13337_2.jpg": "havana",
    "Meir-xNoodCo.-Alchemy-Lifestyle-Basin-Mixer.jpg": "mixer",
    "CAWH39-1500_lifestyle3.jpg": "vanity",
    "AFTER_media_4_b1c79bed-3d93-4679-b9ec-568aa32d7e92.jpg": "bath",
    "AFTER_media_4.jpg": "bath",
    "2635_2.jpg": "otti_vanity",
    "verona-shared-lifestyle-580471_9c4bc591-62f1-4955-aff3-e8d22c8925ae.jpg": "venetta",
    "verona-shared-lifestyle-580471.jpg": "venetta",
    "Meir-xNoodCo_-Alchemy-Lifestyle-Wall-Mixer-Set-2_1__jpg_8470ba75-6020-49ea-a5e1-745e718d4f55.jpg": "wall_combo",
    "Meir-xNoodCo_-Alchemy-Lifestyle-Wall-Mixer-Set-2_1__jpg.jpg": "wall_combo",
    "54552899_Lifestyle_MHA470SHAF_4.jpg": "space_saver",
    "phoenix-117-7920__lifestyle_117-7920-40_Phoenix_Axia_Twin_Shower_Wall_Mixer_2_RGB.jpg": "shower",
    "13296_2.jpg": "led_mirror",
    "lifestyle_133-7120-51_303-7002-51_RA893-51_RA803-51_Linq_2000-Series-Laundry-Sink_RGB.jpg": "basin",
    "10037_2.jpg": "havana",
    "54552899_Lifestyle_LMVAL-1100_3_99c01c92-448d-4d65-be8f-b59ae19454b5.jpg": "vanity",
    "54552899_Lifestyle_LMVAL-1100_3.jpg": "vanity",
    "AFTER_media_2_c61d3d98-26c6-4455-9cd7-fc0e7519cd4e.jpg": "bath",
    "AFTER_media_2.jpg": "bath",
    "14723_3.jpg": "otti_vanity",
    "54552899_Lifestyle_VE750WHA_1.jpg": "venetta",
    "Meir-xNood_Co.-Alchemy-Lifestyle-Wall-Mixer-Set_2_1_-_Copy.jpg": "wall_combo",
    "14819_2.jpg": "space_saver",
    "phoenix-117-7920__lifestyle_117-7920-40_Phoenix_Axia_Twin_Shower_Wall_Mixer_RGB.jpg": "shower",
    "13299_2.jpg": "led_mirror",
    "54552899_Lifestyle_CI420SMW_1.jpg": "basin",
    "lifestyle_117-7810-40_117-7920-40_606-6610-40_Phoenix_Axia_Collection_RGB.jpg": "vanity",
    "Maddison_Freestanding_Bath_44bba2b4-a162-46b6-b390-c554284f7d05.jpg": "bath",
    "Maddison_Freestanding_Bath.jpg": "bath",
    "14722_3.jpg": "otti_vanity",
    "verona-shared-lifestyle-873928_fe659757-d788-4ea3-ae82-86bb077df7c2.jpg": "venetta",
    "verona-shared-lifestyle-873928.jpg": "venetta",
    "phoenix-117-7815__lifestyle_117-7815-10_Phoenix_Axia_Wall_Basin_Bath_Hostess_Set_180mm_RGB.jpg": "wall_combo",
    "54552899_Lifestyle_MRV450SHAF_2.jpg": "space_saver",
    "phoenix-118-7490__118-7900-40-118-7490-40-Phoenix-Teel-Vessel-Mixer-and-Wall-Shower-System-Lifestyle-RGB-scaled_83c10776-c177-4798-bdab-878ef08068f0.jpg": "shower",
    "phoenix-118-7490__118-7900-40-118-7490-40-Phoenix-Teel-Vessel-Mixer-and-Wall-Shower-System-Lifestyle-RGB-scaled.jpg": "shower",
    "13298_2.jpg": "led_mirror",
    "312-5102-80-134-1070-12-134-8500-12-Phoenix-Sinks-Lifestyle-1_BG-alt_RGB_square-scaled.jpg": "basin",
    "CAWH39-1500_lifestyle2.jpg": "vanity",
    "Bella-Biscuit-Side-View_e86bbdb7-b126-4c7e-b202-6e394dc3d701.png": "bath",
    "Bella-Biscuit-Side-View.png": "bath",
    "14724_2.jpg": "otti_vanity",
    "verona-shared-lifestyle-868192_ac181b32-5032-4a54-be13-d886a7522a2c.jpg": "venetta",
    "verona-shared-lifestyle-868192.jpg": "venetta",
    "phoenix-117-7815__lifestyle_117-7815-40_RA893BN_Axia_Wall_Mixer_Set_Radii_Hand_Towel_Holder_RGB_25fd9101-5077-41d6-a0ce-4046da28e81b.jpg": "wall_combo",
    "phoenix-117-7815__lifestyle_117-7815-40_RA893BN_Axia_Wall_Mixer_Set_Radii_Hand_Towel_Holder_RGB.jpg": "wall_combo",
    "54552899_Lifestyle_MHA470SHAF_1.jpg": "space_saver",
    "54552899_Lifestyle_LMVAL-1100_1_c34979c6-f9fe-4e78-9ab9-46862a075d0a.jpg": "vanity",
    "54552899_Lifestyle_LMVAL-1100_1.jpg": "vanity",
    "Nice-Side-View-scaled-e1778753799239_ce6e4b5b-b892-475c-864f-43bacf02f359.png": "bath",
    "Nice-Side-View-scaled-e1778753799239.png": "bath",
    "14723_2.jpg": "otti_vanity",
    "verona-shared-lifestyle-598487.jpg": "venetta",
    "phoenix-117-7800__lifestyle_117-7815-40_RA812BN_117-7800-40_Axia_Wall_Mixer_Set_RGB.jpg": "wall_combo",
    "14819_1.jpg": "space_saver",
    "54552899_Lifestyle_LMVAL-1100_2_437e83a8-42df-492b-b3a7-e2748ec6a6eb.jpg": "vanity",
    "54552899_Lifestyle_LMVAL-1100_2.jpg": "vanity",
    "Briza-Bath-Tub_b28f15ca-5a8d-4c1f-9265-bfddbbf69a10.jpg": "bath",
    "Briza-Bath-Tub.jpg": "bath",
    "14721_3.jpg": "otti_vanity",
    "54552899_Lifestyle_RM750WMWF_1.jpg": "vanity",
    "adp-solace-back-to-wall-g1.jpg": "bath",
    "14729_3.jpg": "otti_vanity",
    "54552899_Lifestyle_RM750WMWF_2.jpg": "vanity",
    "Chelsea-Bathtub-Front-View-Image-2-scaled-e1778665864356_f15f9a45-9eee-4f4d-a1d6-8abea22a7465.png": "bath",
    "Chelsea-Bathtub-Front-View-Image-2-scaled-e1778665864356.png": "bath",
    "14728_3.jpg": "otti_vanity",
    "54552899_Lifestyle_RM1200WMWF_1.jpg": "vanity",
    "AFTER_media_3_175cb9ca-11ac-4d7b-91bf-25f4e0216395.jpg": "bath",
    "AFTER_media_3.jpg": "bath",
    "14721_2.jpg": "otti_vanity",
    "phoenix-117-7920__lifestyle_117-7810-40_117-7920-40_606-6610-40_Phoenix_Axia_Collection_RGB.jpg": "vanity",
    "Bella-Freestanding-Bath-Tub-4_ca9d5df0-9762-469c-a23e-2c46789b1f64.jpg": "bath",
    "Bella-Freestanding-Bath-Tub-4.jpg": "bath",
    "14729_2.jpg": "otti_vanity",
    "54552899_Lifestyle_RM1200WMWF_2.jpg": "vanity",
    "adp-tranquil-g1.jpg": "bath",
    "14727_1.jpg": "otti_vanity",
    "54552899_Lifestyle_RM1500WMWF_2.jpg": "vanity",
    "Onda-Bath-Front-View_8df84ae3-04f0-41ed-921e-ac51daf477e8.jpg": "bath",
    "Onda-Bath-Front-View.jpg": "bath",
    "14727_3.jpg": "otti_vanity",
    "54552899_Lifestyle_RM1500WMWF_1.jpg": "vanity",
    "Romeo-freestanding-bath-2_abca328f-5392-4128-9acf-b78d6460540a.png": "bath",
    "Romeo-freestanding-bath-2.png": "bath",
    "14728_2.jpg": "otti_vanity",
    "CAWH402-1500-Lifestyle.jpg": "vanity",
    "Bora_Freestanding_Bath_1_a3ac3faa-2775-4494-88d4-9dd129bfa08d.jpg": "bath",
    "Bora_Freestanding_Bath_1.jpg": "bath",
    "14724_3.jpg": "otti_vanity",
    "54552899_Lifestyle_RM900WMWF_2.jpg": "vanity",
    "AFTER_media_1_6258902a-4b73-494b-8fec-ea9e71fc7c2b.jpg": "bath",
    "AFTER_media_1.jpg": "bath",
    "14727_2.jpg": "otti_vanity",
    "54552899_Lifestyle_RM900WMWF_1.jpg": "vanity",
    "Bora_Freestanding_Bath_2_1423eb72-b0fc-427b-9324-07c3ef85a2cd.jpg": "bath",
    "Bora_Freestanding_Bath_2.jpg": "bath",
    "CAWH402-1800-Lifestyle.jpg": "vanity",
    "CAWH39-1500_lifestyle4.jpg": "vanity",
    "harper-1500-florentine-walnut_angle_1x1-web.jpg": "vanity"
  };

  function parsePool(raw) {
    if (!raw) return [];
    return String(raw).split('|').map(function (s) { return s.trim(); }).filter(function (s) { return s.length > 8; });
  }
  function masterUrl(url) {
    if (!url) return '';
    return String(url).replace(/^\/\//, 'https://').split('?')[0];
  }
  function fileName(url) {
    var m = masterUrl(url);
    var i = m.lastIndexOf('/');
    return i >= 0 ? m.slice(i + 1) : m;
  }
  function stemName(fn) {
    return String(fn).replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i, '');
  }
  function catOf(url) {
    var fn = fileName(url);
    if (CAT_BY_FN[fn]) return CAT_BY_FN[fn];
    var st = stemName(fn);
    if (CAT_BY_FN[st]) return CAT_BY_FN[st];
    for (var k in CAT_BY_FN) {
      if (k.indexOf(fn.slice(0, 28)) === 0 || fn.indexOf(k.slice(0, 28)) === 0) return CAT_BY_FN[k];
    }
    // heuristic fallback
    var fl = fn.toLowerCase();
    if (/bath|freestanding|bathtub|bronte|glacier|solace|attica/.test(fl)) return 'bath';
    if (/otti|1472|1473|bondi|havana-fluted/.test(fl)) return 'otti_vanity';
    if (/pietra|bianca|bella-free|bora_|autumn|anna-|chelsea|romeo/.test(fl)) return 'bath';
    if (/shower|twin.?shower|vs7630/.test(fl)) return 'shower';
    if (/wall.?mixer|wall.?set|hostess|alchemy-lifestyle-wall/.test(fl)) return 'wall_combo';
    if (/mixer|alchemy-lifestyle-basin/.test(fl)) return 'mixer';
    if (/scbm|sccan|1329/.test(fl)) return 'led_mirror';
    if (/mha470|mrv450|space.?saver|1481/.test(fl)) return 'space_saver';
    if (/ve\d{3}|venetta|verona-shared/.test(fl)) return 'venetta';
    if (/10037|13337/.test(fl)) return 'havana';
    if (/ci420|linq|basin/.test(fl)) return 'basin';
    return 'vanity';
  }
  /* 2026-10-14: width = real frame width x DPR (max 2), in 200px steps, cap 1600 (smaller files, still sharp) */
  var SLOT_W = 0;
  function targetWidth() {
    var w = SLOT_W || window.innerWidth || 1200;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var px = Math.ceil((w * dpr) / 200) * 200;
    return Math.max(400, Math.min(1600, px));
  }
  function sized(url) {
    var m = masterUrl(url);
    if (!m) return url;
    return m + (m.indexOf('?') >= 0 ? '&' : '?') + 'width=' + targetWidth();
  }

  /* -------- Strong shuffle: mulberry32 PRNG + Fisher-Yates, seed = Date.now() -------- */
  function mulberry32(a) {
    return function () {
      var t = (a += 0x6D2B79F5);
      t = Math.imul(t ^ (t >>> 15), t | 1);
      t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  function fisherYates(arr, seed) {
    var a = arr.slice();
    var rand = mulberry32((seed >>> 0) || 1);
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(rand() * (i + 1));
      var tmp = a[i]; a[i] = a[j]; a[j] = tmp;
    }
    return a;
  }
  /** Interleave so no two identical cats are adjacent (best-effort). */
  function diversifyCats(pool, cats) {
    var buckets = {};
    var order = [];
    var i, c, k;
    for (i = 0; i < pool.length; i++) {
      c = cats[i];
      if (!buckets[c]) { buckets[c] = []; order.push(c); }
      buckets[c].push(pool[i]);
    }
    var out = [];
    var guard = pool.length * 3;
    while (out.length < pool.length && guard-- > 0) {
      var progressed = false;
      for (k = 0; k < order.length; k++) {
        c = order[k];
        if (!buckets[c] || !buckets[c].length) continue;
        if (out.length && catOf(out[out.length - 1]) === c) {
          var others = 0;
          for (var o = 0; o < order.length; o++) {
            if (order[o] !== c && buckets[order[o]] && buckets[order[o]].length) others++;
          }
          if (others > 0) continue;
        }
        out.push(buckets[c].shift());
        progressed = true;
      }
      if (!progressed) {
        for (k = 0; k < order.length; k++) {
          while (buckets[order[k]] && buckets[order[k]].length) out.push(buckets[order[k]].shift());
        }
        break;
      }
    }
    return out.length ? out : pool;
  }


  function rangeOf(url) {
    var fn = fileName(url).toLowerCase();
    var m;
    m = fn.match(/\b(rm\d{3,4}|ve\d{3}|cawh\d+|lmval|mha\d+|mrv\d+|ci\d+|scbm|sccan)\b/);
    if (m) return m[1];
    m = fn.match(/\b(bronte|solace|tranquil|glacier|attica|bondi|havana|venetta|verona|harper|alchemy|axia|teel|vivid|bella|bora|chelsea|romeo|onda|briza|maddison|nice-side|nice_side)\b/);
    if (m) return m[1];
    m = fn.match(/\b(1472\d|1473\d|1481\d|2635)\b/);
    if (m) return m[1];
    m = fn.match(/lifestyle[_-]([a-z0-9-]+)/);
    if (m) return m[1].slice(0, 18);
    return stemName(fileName(url)).slice(0, 22).toLowerCase();
  }
  function isOttiUrl(url) {
    var fl = fileName(url).toLowerCase();
    return /otti|1472|1473|2635|bondi|havana-fluted/.test(fl) || catOf(url) === 'otti_vanity';
  }
  function isPbBathUrl(url) {
    var fl = fileName(url).toLowerCase();
    // Prefer room lifestyle PB/baths over blank-bg side/front studio crops
    if (/bella-biscuit-side|nice-side-view|chelsea-bathtub-front|onda-bath-front|hostess|wall_basin_bath/.test(fl)) return false;
    if (/pietra|bora_|romeo-free|bella-freestanding|maddison_freestanding|briza-bath|adp-bronte|adp-solace|adp-tranquil|after_media/.test(fl)) return true;
    return catOf(url) === 'bath';
  }
  function isBathUrl(url) {
    // Category-first; do NOT treat Phoenix "Wall_Basin_Bath_Hostess" wall sets as baths
    if (catOf(url) === 'bath') return true;
    var fl = fileName(url).toLowerCase();
    if (/hostess|wall_basin_bath|wall-basin-bath/.test(fl)) return false;
    return /freestanding|bathtub|bronte|solace|attica|glacier|tranquil|after_media|bora_|romeo-free|bella-freestanding|maddison_freestanding|briza-bath/.test(fl);
  }
  /**
   * Mobile page-load playlist: at most one image per category, unique images,
   * force Otti + PB/bath, no adjacent same range. Length ~= distinct cats.
   */
  function buildMobilePlaylist(rawPool, seed) {
    var shuffled = fisherYates(rawPool, seed);
    var byCat = {};
    var i, c, u;
    for (i = 0; i < shuffled.length; i++) {
      u = shuffled[i];
      c = catOf(u);
      if (!byCat[c]) byCat[c] = [];
      byCat[c].push(u);
    }
    // Force picks first so they win their category slot
    var forced = [];
    var usedUrl = Object.create(null);
    var usedCat = Object.create(null);
    function take(url, catForce) {
      if (!url || usedUrl[masterUrl(url)]) return false;
      var cat = catForce || catOf(url);
      if (usedCat[cat]) return false;
      usedUrl[masterUrl(url)] = 1;
      usedCat[cat] = 1;
      forced.push(url);
      return true;
    }
    // 1) Otti vanity
    for (i = 0; i < shuffled.length && !usedCat['otti_vanity']; i++) {
      if (isOttiUrl(shuffled[i])) take(shuffled[i], 'otti_vanity');
    }
    // 2) Pietra Bianca / lifestyle bath
    for (i = 0; i < shuffled.length; i++) {
      if (isPbBathUrl(shuffled[i]) && take(shuffled[i])) break;
    }
    if (!Object.keys(usedCat).some(function (k) { return k === 'bath'; })) {
      for (i = 0; i < shuffled.length; i++) {
        if (isBathUrl(shuffled[i]) && take(shuffled[i])) break;
      }
    }
    // Fill remaining categories from shuffled order (first hit per cat)
    for (i = 0; i < shuffled.length; i++) {
      u = shuffled[i];
      c = catOf(u);
      if (usedCat[c] || usedUrl[masterUrl(u)]) continue;
      usedCat[c] = 1;
      usedUrl[masterUrl(u)] = 1;
      forced.push(u);
    }
    // Order with Fisher-Yates on forced, then repair adjacent range clashes
    var ordered = fisherYates(forced, (seed ^ 0xA5A5A5A5) >>> 0);
    var guard = ordered.length * 2;
    i = 1;
    while (i < ordered.length && guard-- > 0) {
      if (rangeOf(ordered[i]) === rangeOf(ordered[i - 1]) || catOf(ordered[i]) === catOf(ordered[i - 1])) {
        var swapped = false;
        for (var j = i + 1; j < ordered.length; j++) {
          if (rangeOf(ordered[j]) !== rangeOf(ordered[i - 1]) && catOf(ordered[j]) !== catOf(ordered[i - 1])) {
            var tmp = ordered[i]; ordered[i] = ordered[j]; ordered[j] = tmp;
            swapped = true; break;
          }
        }
        if (!swapped) i++;
        else continue;
      }
      i++;
    }
    // Ensure Otti + PB/bath appear in first 4 so mobile refreshes show them quickly
    function pullEarly(pred, preferSlot) {
      var idx = -1;
      for (var k = 0; k < ordered.length; k++) {
        if (pred(ordered[k])) { idx = k; break; }
      }
      if (idx < 0) return;
      if (idx <= 3) return;
      var slot = preferSlot;
      if (slot < 0 || slot >= ordered.length) slot = 1;
      // find a slot in 0..3 that does not create range clash with neighbors
      var candidates = [preferSlot, 1, 2, 0, 3];
      for (var c = 0; c < candidates.length; c++) {
        slot = candidates[c];
        if (slot < 0 || slot >= ordered.length || slot === idx) continue;
        var leftOk = slot === 0 || rangeOf(ordered[idx]) !== rangeOf(ordered[slot - 1]);
        var rightOk = slot >= ordered.length - 1 || slot + 1 === idx || rangeOf(ordered[idx]) !== rangeOf(ordered[slot + 1 === idx ? idx + 1 : slot + 1]);
        // simpler: swap and verify no adjacent range/cat clash at slot
        var t = ordered[slot]; ordered[slot] = ordered[idx]; ordered[idx] = t;
        var clash = (slot > 0 && (rangeOf(ordered[slot]) === rangeOf(ordered[slot - 1]) || catOf(ordered[slot]) === catOf(ordered[slot - 1]))) ||
          (slot < ordered.length - 1 && (rangeOf(ordered[slot]) === rangeOf(ordered[slot + 1]) || catOf(ordered[slot]) === catOf(ordered[slot + 1])));
        if (!clash) return;
        // revert and try next
        t = ordered[slot]; ordered[slot] = ordered[idx]; ordered[idx] = t;
      }
    }
    pullEarly(isOttiUrl, 1 + (seed % 3));
    pullEarly(isPbBathUrl, seed % 3);
    // HARD guarantee: first 3 slots include real bath + Otti (by category)
    function indexOfCat(catName) {
      for (var k = 0; k < ordered.length; k++) {
        if (catOf(ordered[k]) === catName) return k;
      }
      return -1;
    }
    function swapTo(idx, slot) {
      if (idx < 0 || slot < 0 || idx === slot || slot >= ordered.length) return;
      var t = ordered[slot]; ordered[slot] = ordered[idx]; ordered[idx] = t;
    }
    var bathSlot = seed % 2;          // 0 or 1
    var ottiSlot = 1 + (seed % 2);    // 1 or 2
    if (ottiSlot === bathSlot) ottiSlot = (bathSlot + 1) % 3;
    swapTo(indexOfCat('bath'), bathSlot);
    swapTo(indexOfCat('otti_vanity'), ottiSlot);
    // Fallback filename match if category map missed
    if (indexOfCat('otti_vanity') < 0) {
      for (var k = 0; k < ordered.length; k++) {
        if (isOttiUrl(ordered[k])) { swapTo(k, ottiSlot); break; }
      }
    }
    if (indexOfCat('bath') < 0) {
      for (k = 0; k < ordered.length; k++) {
        if (isPbBathUrl(ordered[k]) || isBathUrl(ordered[k])) { swapTo(k, bathSlot); break; }
      }
    }
    return ordered;
  }
  function pauseFlickity(scope) {
    try {
      var hosts = [];
      if (scope) {
        var a = scope.querySelectorAll('.slideshow, .flickity-enabled, [data-slideshow], .hero');
        for (var i = 0; i < a.length; i++) hosts.push(a[i]);
      }
      hosts.push(document.querySelector('.elenni-hero-carousel .slideshow'));
      hosts.push(document.querySelector('.elenni-hero-carousel .flickity-enabled'));
      for (var h = 0; h < hosts.length; h++) {
        var el = hosts[h];
        if (!el) continue;
        if (el.flickity && typeof el.flickity.pausePlayer === 'function') {
          el.flickity.pausePlayer();
        }
        if (typeof Flickity !== 'undefined' && Flickity.data) {
          var flk = Flickity.data(el);
          if (flk && typeof flk.pausePlayer === 'function') flk.pausePlayer();
        }
        el.setAttribute('data-autoplay', 'false');
      }
      // Theme Slideshow wrapper instances
      if (window.theme && theme.Slideshow) { /* no-op: pause via flickity */ }
    } catch (e) {}
  }

  function findRoot() {
    return document.querySelector('.index-section--hero [data-elenni-hero-pool]') ||
      document.querySelector('[data-elenni-hero-pool]');
  }
  function makePaneImg() {
    var img = document.createElement('img');
    img.className = 'elenni-hero-panes__media';
    img.setAttribute('data-elenni-hero-img', '');
    img.alt = '';
    img.loading = 'lazy';
    img.decoding = 'async';
    img.width = 1100;
    img.height = 900;
    return img;
  }
  function ensurePanes(root, scope, target) {
    var wrap = root.querySelector('.elenni-hero-panes') ||
      (scope && scope.querySelector('.elenni-hero-panes'));
    if (!wrap) return [];
    var panes = wrap.querySelectorAll('.elenni-hero-panes__pane');
    var i;
    for (i = 0; i < panes.length; i++) {
      var vid = panes[i].querySelector('video');
      var existing = panes[i].querySelector('img.elenni-hero-panes__media, img[data-elenni-hero-img], img');
      if (vid && !existing) {
        vid.parentNode.removeChild(vid);
        panes[i].insertBefore(makePaneImg(), panes[i].firstChild);
      }
    }
    panes = wrap.querySelectorAll('.elenni-hero-panes__pane');
    for (i = panes.length; i < target; i++) {
      var pane = document.createElement('div');
      pane.className = 'elenni-hero-panes__pane elenni-hero-panes__pane--js-' + i;
      pane.appendChild(makePaneImg());
      wrap.appendChild(pane);
    }
    panes = wrap.querySelectorAll('.elenni-hero-panes__pane');
    for (i = 0; i < panes.length; i++) {
      panes[i].style.display = i < target ? '' : 'none';
    }
    var out = [];
    for (i = 0; i < panes.length && out.length < target; i++) {
      var im = panes[i].querySelector('img.elenni-hero-panes__media') ||
        panes[i].querySelector('img[data-elenni-hero-img]') ||
        panes[i].querySelector('img');
      if (im) out.push(im);
    }
    return out;
  }
  function slideImgs(root, scope) {
    var host = root.querySelector('.elenni-hero-carousel') ||
      (scope && scope.querySelector('.elenni-hero-carousel')) || root;
    var slides = host.querySelectorAll('.slideshow__slide');
    var out = [];
    for (var i = 0; i < slides.length; i++) {
      var slide = slides[i];
      var img = slide.querySelector('img.hero__image:not(.medium-up--hide)') ||
        slide.querySelector('img.hero__image') ||
        slide.querySelector('img');
      var vid = slide.querySelector('video');
      if (!img && vid) {
        img = document.createElement('img');
        img.className = 'hero__image hero__image--' + (i + 1);
        img.setAttribute('data-elenni-hero-img', '');
        img.alt = '';
        img.loading = 'lazy';
        img.decoding = 'async';
        vid.parentNode.insertBefore(img, vid);
        vid.parentNode.removeChild(vid);
      }
      if (img) out.push(img);
    }
    return out;
  }

  var VISIBLE_IMGS = []; /* speed2 P3: images currently on screen (desktop: all panes; mobile: primary slide) */
  var preloaded = Object.create(null);
  var SERVER_FN = ''; /* 2026-10-15: file name of the server-rendered (preloaded) mobile first frame; never re-download it */
  function preload(url) {
    var u = sized(url);
    if (!u || preloaded[u]) return;
    if (SERVER_FN && fileName(url) === SERVER_FN) return;
    preloaded[u] = true;
    var im = new Image();
    im.decoding = 'async';
    im.src = u;
  }
  function preloadNearby(pool, idxs) {
    for (var a = 0; a < idxs.length; a++) {
      var idx = idxs[a];
      for (var i = 0; i <= PRELOAD_AHEAD; i++) preload(pool[(idx + i) % pool.length]);
    }
  }

  function applyFit(img, url, fit) {
    if (!img || !url) return;
    var u = sized(url);
    if (img.getAttribute('data-elenni-hero-src') === u) return;
    img.setAttribute('data-elenni-hero-src', u);
    img.setAttribute('src', u);
    img.removeAttribute('srcset');
    /* speed2 P3: visible hero image(s) stay eager + high so a rotated frame is never loading=lazy (rotation order/timing unchanged) */
    var elenniVisible = VISIBLE_IMGS.indexOf(img) >= 0;
    img.loading = elenniVisible ? 'eager' : 'lazy';
    img.decoding = 'async';
    img.fetchPriority = elenniVisible ? 'high' : 'low';
    img.style.setProperty('object-fit', fit || 'cover', 'important');
    img.style.setProperty('background-color', '#FAF7F2', 'important');
    img.style.setProperty('object-position', 'center center', 'important');
    img.style.width = '100%';
    img.style.height = '100%';
    img.style.maxWidth = '100%';
    img.style.maxHeight = '100%';
    img.style.minWidth = '0';
    img.style.minHeight = '0';
    img.style.position = 'absolute';
    img.style.inset = '0';
    img.style.padding = '0';
    img.style.margin = '0';
    img.style.transform = 'none';
  }

  /* GO2 2026-10-09 LCP fix: style-only fit (keeps server-rendered src/srcset/eager/high on frame 1) */
  function fitStyles(img, fit) {
    if (!img) return;
    img.style.setProperty('object-fit', fit || 'cover', 'important');
    img.style.setProperty('background-color', '#FAF7F2', 'important');
    img.style.setProperty('object-position', 'center center', 'important');
    img.style.width = '100%';
    img.style.height = '100%';
    img.style.maxWidth = '100%';
    img.style.maxHeight = '100%';
    img.style.minWidth = '0';
    img.style.minHeight = '0';
    img.style.position = 'absolute';
    img.style.inset = '0';
    img.style.padding = '0';
    img.style.margin = '0';
    img.style.transform = 'none';
  }
  /* Run fn after window load (max 3.5s wait) so rotation/preloads don't compete with the LCP image */
  function whenLoaded(fn) {
    var done = false;
    function go() { if (done) return; done = true; setTimeout(fn, 0); }
    if (document.readyState === 'complete') { go(); return; }
    window.addEventListener('load', go, { once: true });
    setTimeout(go, 3500);
  }

  /** Pick next index: different image AND different category from all currently visible. */
  function nextDiverse(from, pool, cats, visibleIdxs, selfSlot) {
    var n = pool.length;
    var avoidUrls = Object.create(null);
    var avoidCats = Object.create(null);
    var i, ix;
    for (i = 0; i < visibleIdxs.length; i++) {
      if (i === selfSlot) continue;
      ix = visibleIdxs[i] % n;
      avoidUrls[masterUrl(pool[ix])] = 1;
      avoidCats[cats[ix]] = 1;
    }
    // also avoid current self cat for a real rotation flip
    avoidCats[cats[from % n]] = 1;
    avoidUrls[masterUrl(pool[from % n])] = 1;
    for (var k = 1; k <= n; k++) {
      var j = (from + k) % n;
      var u = masterUrl(pool[j]);
      if (avoidUrls[u]) continue;
      if (avoidCats[cats[j]]) continue;
      return j;
    }
    // relax: allow same cat but never same image
    for (k = 1; k <= n; k++) {
      j = (from + k) % n;
      if (!avoidUrls[masterUrl(pool[j])]) return j;
    }
    return (from + 1) % n;
  }

  function pickInitialIdxs(pool, cats, count) {
    var idxs = [];
    var usedUrl = Object.create(null);
    var usedCat = Object.create(null);
    var n = pool.length;
    var start = 0;
    var i, j, tries;
    for (i = 0; i < count; i++) {
      var found = -1;
      for (tries = 0; tries < n; tries++) {
        j = (start + tries) % n;
        var u = masterUrl(pool[j]);
        var c = cats[j];
        if (usedUrl[u]) continue;
        if (usedCat[c]) continue;
        found = j; break;
      }
      if (found < 0) {
        for (tries = 0; tries < n; tries++) {
          j = (start + tries) % n;
          if (!usedUrl[masterUrl(pool[j])]) { found = j; break; }
        }
      }
      if (found < 0) found = (start + i) % n;
      idxs.push(found);
      usedUrl[masterUrl(pool[found])] = 1;
      usedCat[cats[found]] = 1;
      start = (found + 1) % n;
    }
    return idxs;
  }

  function boot() {
    var root = findRoot();
    if (!root) return;
    if (root.getAttribute('data-elenni-hero-bound') === '1') return;
    var rawPool = parsePool(root.getAttribute('data-elenni-hero-pool')).map(masterUrl);
    if (rawPool.length < 2) return;
    root.setAttribute('data-elenni-hero-bound', '1');

    var intervalAttr = parseInt(root.getAttribute('data-elenni-hero-interval') || '', 10);
    if (intervalAttr >= 1000 && intervalAttr <= 10000) INTERVAL_MS = intervalAttr;

    var targetAttr = parseInt(root.getAttribute('data-elenni-hero-pane-target') || '', 10);
    var wrap = root.querySelector('.elenni-hero-panes');
    if ((!targetAttr || targetAttr < 1) && wrap) {
      targetAttr = parseInt(wrap.getAttribute('data-elenni-hero-pane-target') || '', 10);
    }
    if (targetAttr >= 1 && targetAttr <= 3) PANE_TARGET = targetAttr;
    else PANE_TARGET = 2;

    // STRONG shuffle every page load / refresh
    var seed = Date.now() ^ ((Math.random() * 0xFFFFFFFF) >>> 0);
    try {
      if (window.crypto && window.crypto.getRandomValues) {
        var buf = new Uint32Array(1);
        window.crypto.getRandomValues(buf);
        seed = (Date.now() ^ buf[0]) >>> 0;
      }
    } catch (e) {}

    var scope = root.closest('.index-section--hero') || root;
    var panes = ensurePanes(root, scope, PANE_TARGET);
    var slides = slideImgs(root, scope);

    var desktop = false;
    try { desktop = window.matchMedia('(min-width: 769px)').matches; } catch (e) {}
    var usePanes = desktop && panes.length > 0;
    var active = usePanes ? panes : (slides.length ? slides : panes);
    if (!active.length) return;
    /* 2026-10-14: contain on desktop too: whole photo, no crop, no stretch, cream #FAF7F2 behind */
    var fit = 'contain';
    try { SLOT_W = Math.round(active[0].parentNode.getBoundingClientRect().width) || 0; } catch (e) {}

    if (active[0]) {
      active[0].loading = 'eager';
      active[0].fetchPriority = 'high';
    }
    VISIBLE_IMGS = usePanes ? Array.prototype.slice.call(active) : [active[0]];

    var pool, cats, idxs, playlist, playCursor;

    if (usePanes) {
      // Desktop LOCKED path — same as v3 twin panes
      var shuffled = fisherYates(rawPool, seed);
      var catsTmp = shuffled.map(catOf);
      pool = diversifyCats(shuffled, catsTmp);
      cats = pool.map(catOf);
      idxs = pickInitialIdxs(pool, cats, active.length);
      for (var i = 0; i < active.length; i++) {
        applyFit(active[i], pool[idxs[i] % pool.length], fit);
      }
      preloadNearby(pool, idxs);
      root.setAttribute('data-elenni-hero-mode', 'panes');
      root.setAttribute('data-elenni-hero-index', idxs.join(','));
      root.setAttribute('data-elenni-hero-cats', idxs.map(function (ix) { return cats[ix]; }).join(','));
      root.setAttribute('data-elenni-hero-visible', idxs.map(function (ix) {
        return fileName(pool[ix % pool.length]);
      }).join('|'));
    } else {
      // MOBILE: page-load playlist — unique image + unique cat; force Otti + PB/bath
      pauseFlickity(scope);
      // Retry pause after theme Flickity boots
      setTimeout(function () { pauseFlickity(scope); }, 600);
      setTimeout(function () { pauseFlickity(scope); }, 1500);

      playlist = buildMobilePlaylist(rawPool, seed);
      if (playlist.length < 2) playlist = fisherYates(rawPool, seed).slice(0, Math.min(8, rawPool.length));
      pool = playlist;
      cats = playlist.map(catOf);
      playCursor = 0;

      // Paint slides as first N playlist entries (playlist already unique-cat + early Otti/PB)
      idxs = [];
      for (var s = 0; s < active.length; s++) {
        idxs.push(Math.min(s, playlist.length - 1));
      }
      // Start PRIMARY on Otti or bath (alternate by seed) so refreshes show both
      var startPrimary = 0;
      var preferOtti = (seed % 2) === 1;
      var ottiIdx = -1, bathIdx = -1;
      for (s = 0; s < Math.min(3, playlist.length); s++) {
        if (ottiIdx < 0 && (isOttiUrl(playlist[s]) || cats[s] === 'otti_vanity')) ottiIdx = s;
        if (bathIdx < 0 && (isPbBathUrl(playlist[s]) || cats[s] === 'bath')) bathIdx = s;
      }
      if (preferOtti && ottiIdx >= 0) startPrimary = ottiIdx;
      else if (bathIdx >= 0) startPrimary = bathIdx;
      else if (ottiIdx >= 0) startPrimary = ottiIdx;
      if (startPrimary !== 0) {
        playlist = playlist.slice(startPrimary).concat(playlist.slice(0, startPrimary));
        cats = playlist.map(catOf);
      }
      // Ensure the OTHER special (otti/bath) is at index 1 so it appears on the next tick
      var otherCat = (cats[0] === 'otti_vanity') ? 'bath' : (cats[0] === 'bath' ? 'otti_vanity' : '');
      if (otherCat) {
        var oj = -1;
        for (s = 1; s < playlist.length; s++) {
          if (cats[s] === otherCat) { oj = s; break; }
        }
        if (oj > 1) {
          var t = playlist[1]; playlist[1] = playlist[oj]; playlist[oj] = t;
          cats = playlist.map(catOf);
        }
      }
      idxs = [];
      for (s = 0; s < active.length; s++) idxs.push(Math.min(s, playlist.length - 1));
      playCursor = 0;
      // GO2 LCP fix: frame 1 = the server-rendered, preloaded first slide (no swap at boot)
      var lcpSrc = active[0] && (active[0].currentSrc || active[0].getAttribute('src'));
      var keepFirst = false;
      /* 2026-10-14 Dorian: random first mobile image again (pre-GO2 behaviour); keep-first disabled */
      /* 2026-10-15 Dorian GO: mobile keep-first restored. Frame 1 = server-rendered preloaded slide stays (LCP stable); rotation armed after first interaction or load+idle */
      if (lcpSrc && fileName(lcpSrc)) {
        var lcpFn = fileName(lcpSrc), lcpAt = -1;
        for (s = 0; s < playlist.length; s++) { if (fileName(playlist[s]) === lcpFn) { lcpAt = s; break; } }
        var lcpUrl = lcpAt >= 0 ? playlist.splice(lcpAt, 1)[0] : masterUrl(lcpSrc);
        playlist.unshift(lcpUrl);
        cats = playlist.map(catOf);
        keepFirst = true;
        SERVER_FN = lcpFn;
      }
      for (i = 0; i < active.length; i++) {
        if (i === 0 && keepFirst) {
          fitStyles(active[0], fit);
          active[0].setAttribute('data-elenni-hero-src', 'server');
          continue;
        }
        applyFit(active[i], playlist[idxs[i]], fit);
      }
      whenLoaded(function () { preloadNearby(playlist, idxs); });

      root.setAttribute('data-elenni-hero-mode', 'carousel');
      root.setAttribute('data-elenni-hero-playlist', String(playlist.length));
      root.setAttribute('data-elenni-hero-index', idxs.join(','));
      root.setAttribute('data-elenni-hero-cats', idxs.map(function (ix) { return cats[ix]; }).join(','));
      root.setAttribute('data-elenni-hero-visible', idxs.map(function (ix) {
        return fileName(playlist[ix]);
      }).join('|'));
      root.setAttribute('data-elenni-hero-has-otti', playlist.some(isOttiUrl) ? '1' : '0');
      root.setAttribute('data-elenni-hero-has-pb', playlist.some(isPbBathUrl) ? '1' : '0');
      root.setAttribute('data-elenni-hero-has-bath', playlist.some(isBathUrl) ? '1' : '0');
      root.setAttribute('data-elenni-hero-playcats', cats.join(','));
      root.setAttribute('data-elenni-hero-playfiles', playlist.map(fileName).join('|'));
    }

    root.setAttribute('data-elenni-hero-seed', String(seed));
    root.setAttribute('data-elenni-hero-count', String(rawPool.length));
    root.setAttribute('data-elenni-hero-start', '0');
    root.setAttribute('data-elenni-hero-active', String(active.length));
    root.setAttribute('data-elenni-hero-autoplay', '1');

    if (reduced) return;

    var timers = [];
    var shownUrls = Object.create(null);
    var shownCats = Object.create(null);
    // Only the PRIMARY visible slide counts as "shown" on this page load.
    // Preview slides must NOT burn Otti/PB/bath before the user sees them.
    if (!usePanes && playlist && idxs.length) {
      shownUrls[masterUrl(playlist[idxs[0]])] = 1;
      shownCats[cats[idxs[0]]] = 1;
    }

    function stopAll() {
      for (var t = 0; t < timers.length; t++) clearInterval(timers[t]);
      timers = [];
    }
    var rotArmed = !!usePanes;
    function startAll() {
      if (!rotArmed || timers.length || document.hidden || reduced) return;
      if (usePanes) {
        for (var p = 0; p < idxs.length; p++) {
          (function (paneI) {
            var delay = 350 * paneI;
            setTimeout(function () {
              if (document.hidden || reduced) return;
              var id = setInterval(function () {
                if (document.hidden) return;
                var next = nextDiverse(idxs[paneI], pool, cats, idxs, paneI);
                idxs[paneI] = next;
                applyFit(active[paneI], pool[idxs[paneI] % pool.length], fit);
                preloadNearby(pool, idxs);
                root.setAttribute('data-elenni-hero-index', idxs.join(','));
                root.setAttribute('data-elenni-hero-cats', idxs.map(function (ix) { return cats[ix]; }).join(','));
                root.setAttribute('data-elenni-hero-visible', idxs.map(function (ix) {
                  return fileName(pool[ix % pool.length]);
                }).join('|'));
              }, INTERVAL_MS);
              timers.push(id);
            }, delay);
          })(p);
        }
      } else {
        // Mobile: advance primary slide through page-load playlist every 2s.
        // Never reuse an image or category already shown on this load.
        // Stop when unique-cat playlist is exhausted — refresh for a new set.
        var id = setInterval(function () {
          if (document.hidden) return;
          pauseFlickity(scope);
          var next = -1;
          // Passes: forward+range, wrap+range, forward no-range, wrap no-range
          // Range is a preference, never a hard skip that drops Otti/PB/bath.
          for (var pass = 0; pass < 4 && next < 0; pass++) {
            var from = (pass % 2 === 0) ? playCursor + 1 : 0;
            var enforceRange = pass < 2;
            for (var abs = from; abs < playlist.length; abs++) {
              var url = playlist[abs];
              var cat = cats[abs];
              if (shownUrls[masterUrl(url)]) continue;
              if (shownCats[cat]) continue;
              if (enforceRange && idxs[0] >= 0 && rangeOf(url) === rangeOf(playlist[idxs[0]])) continue;
              next = abs;
              break;
            }
          }
          if (next < 0) {
            stopAll();
            root.setAttribute('data-elenni-hero-autoplay', '0');
            root.setAttribute('data-elenni-hero-exhausted', '1');
            return;
          }
          playCursor = next;
          shownUrls[masterUrl(playlist[next])] = 1;
          shownCats[cats[next]] = 1;
          idxs[0] = next;
          applyFit(active[0], playlist[next], fit);

          // Previews = upcoming not-yet-shown (do NOT mark shown)
          var previewUsed = Object.create(null);
          previewUsed[next] = 1;
          for (var s = 1; s < active.length; s++) {
            var found = -1;
            for (var m = 0; m < playlist.length; m++) {
              if (previewUsed[m]) continue;
              if (shownUrls[masterUrl(playlist[m])]) continue;
              if (shownCats[cats[m]]) continue; // not yet shown as primary — ok to preview
              // actually allow preview of not-yet-primary cats:
              found = m;
              // prefer m > next for forward feel
            }
            for (m = next + 1; m < playlist.length; m++) {
              if (previewUsed[m]) continue;
              if (shownUrls[masterUrl(playlist[m])]) continue;
              found = m; break;
            }
            if (found < 0) {
              for (m = 0; m < playlist.length; m++) {
                if (previewUsed[m]) continue;
                if (shownUrls[masterUrl(playlist[m])]) continue;
                found = m; break;
              }
            }
            if (found < 0) break;
            previewUsed[found] = 1;
            idxs[s] = found;
            applyFit(active[s], playlist[found], fit);
          }
          preloadNearby(playlist, idxs);
          root.setAttribute('data-elenni-hero-index', idxs.join(','));
          root.setAttribute('data-elenni-hero-cats', idxs.map(function (ix) { return cats[ix]; }).join(','));
          root.setAttribute('data-elenni-hero-visible', idxs.map(function (ix) {
            return fileName(playlist[ix]);
          }).join('|'));
          root.setAttribute('data-elenni-hero-cursor', String(playCursor));
        }, INTERVAL_MS);
        timers.push(id);
      }
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAll();
      else startAll();
    }, { passive: true });

    var resizeT = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(function () {
        try { SLOT_W = Math.round(active[0].parentNode.getBoundingClientRect().width) || 0; } catch (e) {}
        for (var i = 0; i < active.length; i++) {
          if (i === 0 && !usePanes && active[0].getAttribute('data-elenni-hero-src') === 'server') continue; /* keep-first: don't re-swap the LCP frame on resize */
          active[i].removeAttribute('data-elenni-hero-src');
        }
        preloaded = Object.create(null);
        var srcPool = usePanes ? pool : playlist;
        for (i = 0; i < active.length; i++) {
          if (i === 0 && !usePanes && active[0].getAttribute('data-elenni-hero-src') === 'server') continue;
          applyFit(active[i], srcPool[idxs[i] % srcPool.length], fit);
        }
        preloadNearby(srcPool, idxs);
      }, 250);
    }, { passive: true });

    if (usePanes) setTimeout(startAll, 400);
    else {
      /* mobile: hold the first painted frame (LCP) until first interaction, or load + 8s idle */
      var armEvts = ['touchstart', 'scroll', 'click', 'keydown', 'pointerdown', 'wheel'];
      var armed = false;
      var arm = function () {
        if (armed) return; armed = true;
        for (var e = 0; e < armEvts.length; e++) window.removeEventListener(armEvts[e], arm, true);
        rotArmed = true;
        setTimeout(startAll, 400);
      };
      for (var e = 0; e < armEvts.length; e++) window.addEventListener(armEvts[e], arm, { passive: true, capture: true });
      whenLoaded(function () { setTimeout(arm, 8000); });
    }
  }

  window.__elenniHeroLifestyleBoot = boot;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    setTimeout(boot, 0);
  }
})();
